import React, { useEffect } from "react";
import "./Profile_Offcanvas.css";
import { Offcanvas } from "react-bootstrap";
import Black_Btn from "../../Common-Component/Common_Btn/Black_Btn/Black_Btn";
import { Link, useNavigate } from "react-router-dom";
import { myaccountForm } from "../../../features/my_account/Slice";
import { useDispatch, useSelector } from "react-redux";

const menuItems = [
  { path: "/my-order", icon: "approved.png", label: "My Order" },
  { path: "/wishlist", icon: "wishlist.png", label: "My Wishlist" },
  {
    path: "/account-setting",
    icon: "check-mark.png",
    label: "Account Settings",
  },
  { path: "/address-book", icon: "delivery.png", label: "Address Book" },
  { path: "/refer-and-earn", icon: "refer.png", label: "Refer And Earn" },
];

function Profile_Offcanvas({ show, onHide, onHideLogOut }) {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    onHide();
  };

  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    dispatch(myaccountForm());
  }, [dispatch]);
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .filter(Boolean) // remove extra spaces
      .map((word) => word[0].toUpperCase())
      .join("");
  };
  return (
    <section>
      <div className="custom_container">
        <Offcanvas
          show={show}
          onHide={onHide}
          placement="end"
          className="Profile_Offcanvas"
        >
          <Offcanvas.Header closeButton />
          <Offcanvas.Body>
            <div className="profile_name_holder">
              <div className="main_name_circle_holder">
                <div className="name_circle_holder">
                  <h3>{getInitials(user?.name)}</h3>
                </div>
              </div>
              <div className="name_holder">
                <h3>{user?.name}</h3>
              </div>
            </div>

            <div className="offcanvas_menu_holder">
              {menuItems.map(({ path, icon, label }) => (
                <div
                  key={path}
                  className="menu_holder"
                  onClick={() => handleNavigation(path)}
                >
                  <div className="menu_icon_holder">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/Images/Icons/${icon}`}
                      className="menu_icon"
                      alt={label}
                    />
                  </div>
                  <p>{label}</p>
                </div>
              ))}
            </div>

            <div className="offcanvas_btn_holder">
              <Link onClick={onHideLogOut}>
                <Black_Btn btnText="Logout" />
              </Link>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </section>
  );
}

export default Profile_Offcanvas;
